import React from 'react'

import { CustomerBenefitPrint } from './CustomerBenefit'
import { TopicPrint } from './Topic'
import { ComponentPrint } from './Component'

import withWebToPrint from '../hocs/withWebToPrint'

const PrintContainer = ({ contentSelectedForPrint, markContentLoaded }) => {
  return (
    <div id="print-container">
      {contentSelectedForPrint['customer-benefit'].map(({ slug }) => (
        <CustomerBenefitPrint
          slug={slug}
          key={slug}
          onMounted={slug => markContentLoaded('customer-benefit', slug)}
        />
      ))}

      {contentSelectedForPrint['topic'].map(({ slug }) => (
        <TopicPrint
          slug={slug}
          key={slug}
          onMounted={slug => markContentLoaded('topic', slug)}
        />
      ))}

      {contentSelectedForPrint['component'].map(({ slug }) => (
        <ComponentPrint
          slug={slug}
          key={slug}
          onMounted={slug => markContentLoaded('component', slug)}
        />
      ))}
    </div>
  )
}

export default withWebToPrint(PrintContainer)



// WEBPACK FOOTER //
// ./src/screens/PrintContainer.js